import BigNumber from 'bignumber.js'

const STORAGE_KEY = 'hieswap_gas_speed_v1'

/** @type {Record<string, number | null>} */
export const GAS_SPEED_PRESETS = {
  default: null,
  instant: 0.07,
  standard: 0.05,
  fast: 0.06,
}

const VALID_IDS = Object.keys(GAS_SPEED_PRESETS)

export function readGasSpeedPreset() {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v && VALID_IDS.includes(v)) return v
  } catch (_e) {
    void _e
  }
  return 'default'
}

export function setGasSpeedPreset(id) {
  if (!VALID_IDS.includes(id)) return
  try {
    localStorage.setItem(STORAGE_KEY, id)
  } catch (_e) {
    void _e
  }
}

export function getUserGasGwei() {
  return GAS_SPEED_PRESETS[readGasSpeedPreset()] ?? null
}

/**
 * Apply user gas speed preset on top of computed network gas (wei string).
 * `default` keeps computed value; presets bump to max(computed, user, chain floor).
 * 不可把 FON 等链的 live gas 压到 floor 以下（否则 MetaMask 上链失败）。
 */
export function applyUserGasSpeedWei(computedWei, chainConf = {}) {
  let gasWei = new BigNumber(computedWei)
  const gwei = getUserGasGwei()
  if (gwei == null) {
    return gasWei.integerValue(BigNumber.ROUND_CEIL).toFixed(0)
  }

  let userWei = new BigNumber(gwei).times(1e9)
  const floorGwei = Number(chainConf.gasPriceFloor ?? 0)
  if (Number.isFinite(floorGwei) && floorGwei > 0) {
    const floorWei = new BigNumber(floorGwei).times(1e9)
    if (userWei.lt(floorWei)) userWei = floorWei
  }
  if (userWei.gt(gasWei)) gasWei = userWei
  return gasWei.integerValue(BigNumber.ROUND_CEIL).toFixed(0)
}

export const GAS_SPEED_UI_ORDER = ['default', 'instant', 'standard', 'fast']
